import Enum from "./Enum";

export default Enum.create( {
	CAREER_PLAN: "CAREER_PLAN",
	WORK_PRIORITY: "WORK_PRIORITY",
	BURNOUT: "BURNOUT",
	DIFFICULT_CONVERSATIONS: "DIFFICULT_CONVERSATIONS",
	SOLICIT_FEEDBACK: "SOLICIT_FEEDBACK",
	RELATIONSHIPS: "RELATIONSHIPS",
	WORK_VALUE: "WORK_VALUE",
} );
